import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Option, ReplyItem } from '../../../../classes';
import { RepliesPerOptionComponent } from './replies-per-option.component';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { PartialOption } from '../../charts.types';

@Injectable()
export class RepliesPerOptionService {

  constructor(
    private modalService : BsModalService,
  ) { }
  open (option:PartialOption, replies:Observable<ReplyItem[]>):Promise<any> {
    return new Promise((resolve, reject)=>{
      const modal:BsModalRef = this.modalService.show(RepliesPerOptionComponent, {class:'modal-lg', initialState:{
        option, replies
      }});
      modal.content.action.pipe(take(1)).subscribe(data=>{
        resolve(data);
      });
    });
  }
}
